module.exports = __webpack_public_path__ + "assets/img/six.b65bb828.png";